// Strings added with the Team / Calendar / Settings / Mentor directory redesign
// (pages Team, TeamHub, Calendar, MentorProfile, MentorDirectory). The older page strings stay in
// the base `team`, `calendar`, `settings` and `directory` dictionaries; a key here replaces a base
// string only where the page asks for this one (a calmer word, no baked dashes or "…").
const teamCalendar = {
  en: {
    clearFilters: 'Clear filters',
    nameRequired: 'Enter a name',
    titleRequired: 'Enter a title',
    dateRequired: 'Pick a date',
    subtitle: 'Plan lessons, deadlines and team events.',
    viewAria: 'Calendar view',
    viewMode: 'View',
    categoryActions: 'Category actions',
    addEvent: 'Add event',
    addEventOn: 'Add an event on {date}',
    weekEmpty: 'Nothing planned',
    removeFilter: 'Remove filter: {name}',
    allDay: 'All day',
    dayEmptyTitle: 'Nothing planned for this day',
    dayEmptyDesc: 'Add an event and it will show up here.',
    deleteEventNote: 'This cannot be undone.',
    deleteCategoryTitle: 'Delete this category?',
    deleteCategoryNote: 'Its events stay on the calendar without a category.',
    icons: {
      BookOpen: 'Book', Star: 'Star', Bell: 'Bell', Calendar: 'Calendar', Clock: 'Clock', Users: 'People',
      Briefcase: 'Work', CheckCircle: 'Done', Flag: 'Flag', Heart: 'Heart', Zap: 'Spark', Target: 'Goal',
    },
    hub: {
      subtitle: 'Manage accounts and split staff into teams.',
      tabPeople: 'Users',
    },
    people: {
      searchPlaceholder: 'Name or email...',
      rolesAria: 'Filter by role',
      actionsFor: 'Actions for {name}',
      roleChangeTitle: 'Change role?',
      roleChangeDesc: "{name}'s role: {from} → {to}. Access updates right away.",
      roleChangeAdmin: 'An admin can open every section.',
      roleChangeConfirm: 'Change',
      joinedOn: 'Joined {date}',
      noneTitle: 'No users yet',
      noneDesc: 'Add the first one with the button above.',
      duplicate: 'This email or phone is already in use.',
    },
    calendar: {
      noCategory: 'No category',
      placeholderDescription: 'Optional notes...',
      start: 'Starts',
      end: 'Ends',
      endBeforeStart: 'The end must be after the start',
      endNeedsStart: 'Pick a start time first',
      nowLabel: 'Now',
      colors: {
        yellow: 'Yellow', green: 'Green', indigo: 'Indigo', coral: 'Coral', teal: 'Teal',
        pink: 'Pink', cyan: 'Cyan', lime: 'Lime', orange: 'Orange', gray: 'Gray',
      },
    },
    settings: {
      navSession: 'Session',
      sessionTitle: 'Session',
      signOut: 'Sign out',
      signOutDesc: 'Sign out of your account on this device. Other devices stay signed in.',
      changePassword: 'Change password',
      notSet: 'Not added',
      contactHint: 'An administrator can change your email and phone.',
      photoHint: 'JPG, PNG, GIF or WebP, up to 5 MB.',
      copyId: 'Copy account ID',
      copied: 'Copied',
      showPassword: 'Show password',
      hidePassword: 'Hide password',
      navAppearance: 'Appearance',
      appearanceTitle: 'Appearance',
      appearanceDesc: 'Language and theme are saved on this device.',
      language: 'Language',
      theme: 'Theme',
      themeLight: 'Light',
      themeDark: 'Dark',
      themeSystem: 'System',
    },
    mentors: {
      title: 'Teachers',
      subtitle: 'Teachers on the platform. Search by name or email.',
      searchPlaceholder: 'Search by name or email...',
      loading: 'Loading teachers...',
      emptyTitle: 'No teachers found',
      emptyDesc: 'Try another word or clear the search.',
      noneTitle: 'No teachers yet',
      noneDesc: 'Add a teacher account on the Team page and it will show up here.',
      since: 'Since {date}',
    },
  },
  ru: {
    clearFilters: 'Сбросить фильтры',
    nameRequired: 'Введите название',
    titleRequired: 'Введите название',
    dateRequired: 'Выберите дату',
    subtitle: 'Планируйте занятия, сроки и события команды.',
    viewAria: 'Вид календаря',
    viewMode: 'Вид',
    categoryActions: 'Действия с категорией',
    addEvent: 'Добавить событие',
    addEventOn: 'Добавить событие: {date}',
    weekEmpty: 'Ничего не запланировано',
    removeFilter: 'Убрать фильтр: {name}',
    allDay: 'Весь день',
    dayEmptyTitle: 'На этот день ничего не запланировано',
    dayEmptyDesc: 'Добавьте событие, и оно появится здесь.',
    deleteEventNote: 'Это действие нельзя отменить.',
    deleteCategoryTitle: 'Удалить категорию?',
    deleteCategoryNote: 'События останутся в календаре без категории.',
    icons: {
      BookOpen: 'Книга', Star: 'Звезда', Bell: 'Колокольчик', Calendar: 'Календарь', Clock: 'Часы', Users: 'Люди',
      Briefcase: 'Работа', CheckCircle: 'Готово', Flag: 'Флаг', Heart: 'Сердце', Zap: 'Молния', Target: 'Цель',
    },
    hub: {
      subtitle: 'Управляйте аккаунтами и распределяйте сотрудников по командам.',
      tabPeople: 'Пользователи',
    },
    people: {
      searchPlaceholder: 'Имя или email...',
      rolesAria: 'Фильтр по роли',
      actionsFor: 'Действия: {name}',
      roleChangeTitle: 'Изменить роль?',
      roleChangeDesc: 'Роль {name}: {from} → {to}. Права доступа обновятся сразу.',
      roleChangeAdmin: 'Администратор получает доступ ко всем разделам.',
      roleChangeConfirm: 'Изменить',
      joinedOn: 'Добавлен {date}',
      noneTitle: 'Пока нет пользователей',
      noneDesc: 'Добавьте первого кнопкой выше.',
      duplicate: 'Этот email или телефон уже занят.',
    },
    calendar: {
      noCategory: 'Без категории',
      placeholderDescription: 'Необязательное описание...',
      start: 'Начало',
      end: 'Конец',
      endBeforeStart: 'Конец должен быть позже начала',
      endNeedsStart: 'Сначала выберите время начала',
      nowLabel: 'Сейчас',
      colors: {
        yellow: 'Жёлтый', green: 'Зелёный', indigo: 'Индиго', coral: 'Коралловый', teal: 'Бирюзовый',
        pink: 'Розовый', cyan: 'Голубой', lime: 'Салатовый', orange: 'Оранжевый', gray: 'Серый',
      },
    },
    settings: {
      navSession: 'Сеанс',
      sessionTitle: 'Сеанс',
      signOut: 'Выйти из аккаунта',
      signOutDesc: 'Выйдите из аккаунта на этом устройстве. Другие устройства не затрагиваются.',
      changePassword: 'Изменить пароль',
      notSet: 'Не указан',
      contactHint: 'Email и телефон может изменить администратор.',
      photoHint: 'JPG, PNG, GIF или WebP, до 5 МБ.',
      copyId: 'Скопировать ID аккаунта',
      copied: 'Скопировано',
      showPassword: 'Показать пароль',
      hidePassword: 'Скрыть пароль',
      navAppearance: 'Оформление',
      appearanceTitle: 'Оформление',
      appearanceDesc: 'Язык и тема сохраняются на этом устройстве.',
      language: 'Язык',
      theme: 'Тема',
      themeLight: 'Светлая',
      themeDark: 'Тёмная',
      themeSystem: 'Системная',
    },
    mentors: {
      title: 'Преподаватели',
      subtitle: 'Преподаватели платформы. Ищите по имени или email.',
      searchPlaceholder: 'Поиск по имени или email...',
      loading: 'Загрузка преподавателей...',
      emptyTitle: 'Преподаватели не найдены',
      emptyDesc: 'Попробуйте другое слово или очистите поиск.',
      noneTitle: 'Преподавателей пока нет',
      noneDesc: 'Добавьте аккаунт преподавателя на странице «Команда», и он появится здесь.',
      since: 'С {date}',
    },
  },
  uz: {
    clearFilters: 'Filtrlarni tozalash',
    nameRequired: 'Nomini kiriting',
    titleRequired: 'Sarlavhani kiriting',
    dateRequired: 'Sanani tanlang',
    subtitle: 'Darslar, muddatlar va jamoa tadbirlarini rejalashtiring.',
    viewAria: "Kalendar ko'rinishi",
    viewMode: "Ko'rinish",
    categoryActions: 'Kategoriya amallari',
    addEvent: "Tadbir qo'shish",
    addEventOn: "{date} uchun tadbir qo'shish",
    weekEmpty: "Reja yo'q",
    removeFilter: 'Filtrni olib tashlash: {name}',
    allDay: "Kun bo'yi",
    dayEmptyTitle: "Bu kunga reja yo'q",
    dayEmptyDesc: "Tadbir qo'shing, u shu yerda ko'rinadi.",
    deleteEventNote: "Buni qaytarib bo'lmaydi.",
    deleteCategoryTitle: "Bu kategoriyani o'chirasizmi?",
    deleteCategoryNote: 'Tadbirlar kalendarda kategoriyasiz qoladi.',
    icons: {
      BookOpen: 'Kitob', Star: 'Yulduz', Bell: "Qo'ng'iroq", Calendar: 'Kalendar', Clock: 'Soat', Users: 'Odamlar',
      Briefcase: 'Ish', CheckCircle: 'Bajarildi', Flag: 'Bayroq', Heart: 'Yurak', Zap: 'Chaqmoq', Target: 'Maqsad',
    },
    hub: {
      subtitle: "Hisoblarni boshqaring va xodimlarni jamoalarga bo'ling.",
      tabPeople: 'Foydalanuvchilar',
    },
    people: {
      searchPlaceholder: 'Ism yoki email...',
      rolesAria: "Rol bo'yicha filtr",
      actionsFor: '{name} uchun amallar',
      roleChangeTitle: "Rolni o'zgartirasizmi?",
      roleChangeDesc: '{name} roli: {from} → {to}. Kirish huquqlari darhol yangilanadi.',
      roleChangeAdmin: "Admin barcha bo'limlarga kirish huquqini oladi.",
      roleChangeConfirm: "O'zgartirish",
      joinedOn: "Qo'shilgan: {date}",
      noneTitle: "Hali foydalanuvchilar yo'q",
      noneDesc: "Birinchisini yuqoridagi tugma bilan qo'shing.",
      duplicate: 'Bu email yoki telefon raqami allaqachon band.',
    },
    calendar: {
      noCategory: 'Kategoriyasiz',
      placeholderDescription: 'Ixtiyoriy izoh...',
      start: 'Boshlanishi',
      end: 'Tugashi',
      endBeforeStart: "Tugash vaqti boshlanishdan keyin bo'lsin",
      endNeedsStart: 'Avval boshlanish vaqtini tanlang',
      nowLabel: 'Hozir',
      colors: {
        yellow: 'Sariq', green: 'Yashil', indigo: 'Indigo', coral: 'Marjon', teal: 'Firuza',
        pink: 'Pushti', cyan: 'Havorang', lime: 'Limon', orange: "To'q sariq", gray: 'Kulrang',
      },
    },
    settings: {
      navSession: 'Seans',
      sessionTitle: 'Seans',
      signOut: 'Hisobdan chiqish',
      signOutDesc: "Bu qurilmadagi hisobingizdan chiqing. Boshqa qurilmalar ta'sirlanmaydi.",
      changePassword: "Parolni o'zgartirish",
      notSet: "Qo'shilmagan",
      contactHint: "Email va telefonni administrator o'zgartira oladi.",
      photoHint: "JPG, PNG, GIF yoki WebP, 5 MB gacha.",
      copyId: 'Hisob ID ni nusxalash',
      copied: 'Nusxalandi',
      showPassword: "Parolni ko'rsatish",
      hidePassword: 'Parolni yashirish',
      navAppearance: "Ko'rinish",
      appearanceTitle: "Ko'rinish",
      appearanceDesc: 'Til va mavzu shu qurilmada saqlanadi.',
      language: 'Til',
      theme: 'Mavzu',
      themeLight: "Yorug'",
      themeDark: "Qorong'i",
      themeSystem: 'Tizim',
    },
    mentors: {
      title: "O'qituvchilar",
      subtitle: "Platformadagi o'qituvchilar. Ism yoki email bo'yicha qidiring.",
      searchPlaceholder: "Ism yoki email bo'yicha qidirish...",
      loading: "O'qituvchilar yuklanmoqda...",
      emptyTitle: "O'qituvchilar topilmadi",
      emptyDesc: "Boshqa so'z bilan urinib ko'ring yoki qidiruvni tozalang.",
      noneTitle: "Hali o'qituvchilar yo'q",
      noneDesc: "Jamoa sahifasida o'qituvchi hisobini qo'shing, u shu yerda ko'rinadi.",
      since: '{date} dan',
    },
  },
};

export default teamCalendar;
